import { X } from '@phosphor-icons/react'
import { isBefore, subMinutes } from 'date-fns'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { GlobalCatcher } from '@/src/@types/statamic'
import Button from '@/src/components/core/Button'
import { ensureTrailingSlash } from '@/src/lib/str'

export default function Catcher({
  catcher_text,
  link,
  button_text,
  is_active,
}: GlobalCatcher['globalCatcher']) {
  const router = useRouter()
  const [closed, setClosed] = useState(false)
  const closeCatcher = () => {
    setClosed(true)
    window.localStorage.setItem('catcherClosedAt', new Date().toISOString())
  }

  useEffect(() => {
    const catcherClosedAt = window.localStorage.getItem('catcherClosedAt')

    if (!catcherClosedAt) {
      return
    }

    if (isBefore(new Date(catcherClosedAt), subMinutes(new Date(), 5))) {
      return
    }

    setClosed(true)
  }, [setClosed])

  if (!catcher_text) {
    return null
  }

  if (closed) {
    return null
  }

  if (!is_active) {
    return null
  }

  const pathname = Array.isArray(router.query['uri'])
    ? router.query['uri'][0]
    : router.query['uri']

  if (
    pathname &&
    link?.url &&
    ensureTrailingSlash(link.url) === '/' + ensureTrailingSlash(pathname)
  ) {
    return null
  }

  return (
    <div className="relative -z-10 mt-16 w-full bg-linear-to-b from-purple-600 to-purple-800 text-white xl:mt-0">
      <div className="relative mx-auto max-w-container items-center justify-between px-5 py-4 lg:flex lg:px-6 lg:py-3">
        <p className="mr-8 lg:mr-0">{catcher_text}</p>
        <div className="mt-3 flex shrink-0 items-center lg:mt-0">
          <Link href={link!.url} className="-m-3 block p-3 font-bold">
            {button_text}
          </Link>
          <div className="absolute top-3 right-3 -m-1.5 ml-3.5 lg:static">
            <Button
              version="white-transparent"
              type="button"
              size="icon-small"
              icon={<X />}
              onClick={closeCatcher}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
